<template>
    <div class="md:max-w-screen-xl w-full mx-auto">
        <div class="stats-table-shell" v-if="responses">
            <div class="stats-table-scroll">
                <table-lite
                    :is-slot-mode="true"
                    :is-static-mode="true"
                    :is-loading="loading"
                    :columns="columns"
                    :rows="responses"
                    :messages="messages"
                    :total="responses.length"
                    :sortable="sortable"
                    :pageOptions="pageOptions"
                >
                    <template v-slot:attendance_status="data">
                        <div v-if="data.value.response_adults" class="indicator">
                            <span
                                v-if="data.value.response_menu_type == 'vegetarian'"
                                class="indicator-item badge badge-primary shadow-md"
                            >
                                <font-awesome-icon icon="fa-solid fa-leaf" />
                            </span>

                            <div class="join">
                                <div
                                    class="join-item badge badge-primary badge-lg"
                                    v-if="data.value.attendance_status == 'Attending'"
                                >
                                    <font-awesome-icon icon="fa-solid fa-user-check" />
                                    <span class="pl-2">Participa</span>
                                </div>
                                <div
                                    class="join-item badge bg-blue-500 text-white badge-lg"
                                    v-if="data.value.attendance_status == 'Attending'"
                                >
                                    <div class="tooltip" data-tip="Numar Adulti">
                                        <span
                                            ><font-awesome-icon
                                                class=""
                                                icon="fa-solid fa-users"
                                            />{{ data.value.response_adults }}</span
                                        >
                                    </div>
                                </div>

                                <div
                                    class="join-item badge bg-blue-600 text-white badge-lg"
                                    v-if="data.value.response_children"
                                >
                                    <div class="tooltip" data-tip="Numar Copii">
                                        <span v-if="data.value.response_children"
                                            ><font-awesome-icon
                                                class=""
                                                icon="fa-solid fa-children"
                                            />{{ data.value.response_children }}</span
                                        >
                                    </div>
                                </div>
                                <div
                                    class="join-item badge bg-blue-700 text-white badge-lg"
                                    v-if="data.value.response_accommodation"
                                >
                                    <div class="tooltip" data-tip="Cazare">
                                        <font-awesome-icon icon="fa-solid fa-bed" />
                                    </div>
                                </div>

                                <div
                                    class="join-item badge bg-blue-800 text-white badge-lg"
                                    v-if="data.value.response_children_menu"
                                >
                                    <div class="tooltip" data-tip="Meniu Copii">
                                        <font-awesome-icon
                                            icon="fa-solid fa-candy-cane"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="badge badge-accent badge-lg"
                            v-if="data.value.attendance_status == 'Not Attending'"
                        >
                            <font-awesome-icon icon="fa-solid fa-user-slash" />
                            <span class="pl-2">Nu Participa</span>
                        </div>
                    </template>

                    <template v-slot:email_sent_time="data">
                        <div class="grid grid-cols-3">
                            <div
                                class="tooltip cursor-default pl-1"
                                :data-tip="`Invitatie trimisa prin Email la ${data.value.email_sent_time}`"
                                v-if="data.value.email_sent_time"
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-envelope-circle-check"
                                    class="text-primary text-2xl"
                                />
                            </div>

                            <div
                                class="tooltip cursor-default"
                                :data-tip="`Invitatia nu a fost trimisa`"
                                v-else
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-envelope"
                                    class="text-base-300 text-2xl"
                                />
                            </div>

                            <div
                                class="tooltip cursor-default pl-1"
                                :data-tip="`Invitatie trimisa prin SMS la ${data.value.sms_sent_time}`"
                                v-if="data.value.sms_sent_time"
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-mobile-screen"
                                    class="text-primary text-2xl"
                                />
                            </div>

                            <div
                                class="tooltip cursor-default"
                                :data-tip="`Invitatia nu a fost trimisa`"
                                v-else
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-mobile-screen"
                                    class="text-base-300 text-2xl"
                                />
                            </div>

                            <div
                                class="tooltip cursor-default"
                                :data-tip="`Invitatie vizualizata la ${data.value.opened_time}`"
                                v-if="data.value.opened_time"
                            >
                                <font-awesome-icon
                                    icon="fa-solid fa-eye"
                                    class="text-primary text-2xl"
                                />
                            </div>
                            <div v-else>
                                <font-awesome-icon
                                    icon="fa-solid fa-eye-slash"
                                    class="text-base-300 text-2xl"
                                />
                            </div>
                        </div>
                    </template>

                    <template v-slot:invitation_id="data">
                        <button
                            @click="openDeleteModal(data.value)"
                            class="btn btn-sm btn-square hover:btn-accent tooltip tooltip-left"
                            data-tip="Sterge"
                        >
                            <font-awesome-icon icon="fa-solid fa-user-xmark" />
                        </button>
                    </template>
                </table-lite>
            </div>
        </div>
        <p v-if="responses.length === 0" class="text-gray-500 mt-4">
            Momentan nu sunt date disponibile.
        </p>

        <ModalComponent :is-open="isDeleteModalOpen" @close="closeDeleteModal">
            <!-- Content for Modal 1 -->

            <h3 class="font-bold text-lg">Sterge Invitat</h3>
            <p class="py-4"></p>
            <p>
                Urmeaza sa stergi raspunsul invitatului
                <span class="font-bold"
                    >{{ selectedDeleteResponse.response_name }}
                    {{ selectedDeleteResponse.response_surname }}</span
                >.
            </p>
            <p>Aceasta actiune este ireversibila.</p>
            <div class="modal-action justify-center">
                <form method="dialog">
                    <button
                        @click="closeDeleteModal"
                        class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                    >
                        ✕
                    </button>

                    <button class="btn mr-5" @click="closeDeleteModal">
                        Anuleaza
                    </button>

                    <button
                        @click="
                            deleteResponse(selectedDeleteResponse.response_id)
                        "
                        class="btn btn-accent"
                    >
                        Am inteles, sterge invitatul
                    </button>
                </form>
            </div>
        </ModalComponent>

        <div v-if="loading">
            <LoadingComponent></LoadingComponent>
        </div>
    </div>
</template>

<script>
import TableLite from 'vue3-table-lite';
import LoadingComponent from './LoadingComponent.vue';
import ModalComponent from '@/components/ModalComponent.vue';
import { useToast } from 'vue-toastification';
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
    props: ['projectId'],
    components: { TableLite, LoadingComponent, ModalComponent },
    data() {
        return {
            isDeleteModalOpen: false,
            selectedDeleteResponse: {},
            isEditModalOpen: false,
            editedParticipant: {},
            selectedProject: null,
            responses: [],
            pageOptions: [
                { value: 100, text: 100 },
                { value: 150, text: 150 },
                { value: 200, text: 200 },
            ],
            columns: [
                {
                    label: 'Nume',
                    field: 'response_surname',
                    width: '10%',
                    sortable: true,
                },
                {
                    label: 'Prenume',
                    field: 'response_name',
                    width: '10%',
                    sortable: true,
                },
                {
                    label: 'Status Participare',
                    field: 'attendance_status',
                    width: '10%',
                    sortable: true,
                },
                {
                    label: 'Mesaj',
                    field: 'response_message',
                    width: '15%',
                    sortable: true,
                },
                {
                    label: 'Actiuni',
                    field: 'invitation_id',
                    width: '5%',
                    sortable: false,
                },
            ],
            sortable: {
                order: 'recipient_name',
                sort: 'desc',
            },
            messages: {
                pagingInfo:
                    'Se afiseaza {0} din {1} rezultate | Total {2} rezultate',
                pageSizeChangeLabel: 'Numar randuri afisate: ',
                gotoPageLabel: ' Mergi la pagina: ',
                noDataAvailable: 'Nu sunt disponibile informatii',
            },
        };
    },
    setup() {
        // Get toast interface
        const toast = useToast();

        // Make it available inside methods
        return { toast };
    },
    mounted() {
        this.getSimpleResponses();
    },
    computed: {
        ...mapGetters([
            'projects',
            'plan',
            'loading',
            'scopedProjectData',
            'stats',
        ]),
    },
    methods: {
        openDeleteModal(participant) {
            this.isDeleteModalOpen = true;
            this.selectedDeleteResponse = participant;
        },
        closeDeleteModal() {
            this.isDeleteModalOpen = false;
        },
        async deleteResponse(responseId) {
            this.closeDeleteModal();
            const projectId = this.projectId;

            try {
                const deleteResponse = await this.$store.dispatch(
                    'deleteResponse',
                    {
                        responseId,
                        projectId,
                    }
                );

                if (deleteResponse && deleteResponse.success == true) {
                    this.toast.success(
                        `Intrarea a fost stersa din lista de raspunsuri!`
                    );

                    // Remove the entry from the participants array
                    // const index = this.responses.findIndex(
                    //     (response) =>
                    //         response.response_id === deleteResponse.responseId
                    // );

                    // if (index !== -1) {
                    //     this.responses.splice(index, 1);
                    // }

                    // Reload the page
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            } catch (error) {
                this.toast.error(`Intrarea nu a putut fi stearsa`);
            }
        },
        async getSimpleResponses() {
            try {
                const jwtToken = localStorage.getItem('userToken');
                this.$store.commit('setLoading', true);

                await axios
                    .get(
                        `/api/index.php?endpoint=getSimpleResponses&projectID=${this.projectId}`,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${jwtToken}`,
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.success) {
                            this.responses = response.data.responses;
                        }

                        this.$store.dispatch('setStatsSimple', this.responses);
                        this.$store.commit('setLoading', false);
                    });
            } catch (error) {
                this.$store.commit('setLoading', false);
                console.error(
                    'A aparut o eroare:',
                    error.response ? error.response.data : error.message
                );
            }
        },
    },
};
</script>

<style>
.stats-table-shell {
    border: 1px solid #dbe3ef;
    border-radius: 1.1rem;
    background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
    padding: 0.7rem;
}

.stats-table-scroll {
    width: 100%;
    overflow-x: auto;
}

.stats-table-shell .vtl-table {
    min-width: 760px;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid #d8e2f0;
    border-radius: 0.9rem;
    overflow: visible;
}

.stats-table-shell .vtl-table .vtl-thead .vtl-thead-th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: linear-gradient(180deg, #334155 0%, #1e293b 100%);
    color: #f8fafc;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 0.7rem;
    font-weight: 800;
    border-bottom: 1px solid #1e293b;
    padding: 0.7rem 0.75rem;
}

.stats-table-shell .vtl-table tbody td {
    padding: 0.75rem;
    border-bottom: 1px solid #e8eef7;
    color: #1e293b;
    vertical-align: middle;
    font-size: 0.85rem;
}

.stats-table-shell .vtl-table tbody tr:nth-child(odd) td {
    background: #f8fbff;
}

.stats-table-shell .vtl-table tbody tr:nth-child(even) td {
    background: #ffffff;
}

.stats-table-shell .vtl-table tbody tr:hover td {
    background: #eaf3ff;
}

.stats-table-shell .vtl-table tbody tr:last-child td {
    border-bottom: 0;
}

.stats-table-shell .vtl-paging {
    border-top: 1px solid #dbe3ef;
    padding-top: 0.6rem;
    margin-top: 0.2rem;
    color: #475569;
    font-size: 0.79rem;
}

.stats-table-shell .vtl-paging select {
    border: 1px solid #cbd5e1;
    border-radius: 0.35rem;
    background: #ffffff;
}

@media (max-width: 640px) {
    .stats-table-shell {
        padding: 0.45rem;
        border-radius: 0.85rem;
    }

    .stats-table-shell .vtl-table {
        min-width: 690px;
    }

    .stats-table-shell .vtl-table .vtl-thead .vtl-thead-th,
    .stats-table-shell .vtl-table tbody td {
        padding: 0.6rem 0.58rem;
    }
}
</style>
